import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import { athleteCard, styles } from './styles'
import { profileUserImageUrl } from '../../utils/profileImageUrl'
import { Bib } from '../../components/shared/athlete/Bib'
import { AthletePhoto } from '../../components/athlete/AthletePhoto'
import { colors } from '../../shared/styles'

class AthleteRacePageCardComponent extends Component {
  static propTypes = {
    isPublicProfile: PropTypes.bool,
    t: PropTypes.func
  }

  render() {
    const athleteCardModel = this.props.athleteCardModel || {}
    const {
      ageOnRaceDate,
      bib,
      claimed,
      entryId,
      firstName,
      gender,
      isFollowed,
      isLoggedIn,
      isMe,
      lastName,
      location,
      racerId
    } = athleteCardModel
    const {
      isMobile,
      isPublicProfile,
      t
    } = this.props

    const profPicUrl = profileUserImageUrl(racerId, 't', !!racerId, true)
    const displayName = firstName + ' ' + lastName
    const genderAndAge = (_.startCase(gender) || '') +
      (gender && ageOnRaceDate ? ', ' : '') +
      (ageOnRaceDate || '')

      const homeTown = `${location.city}, ${location.region}, ${location.country}`
      const imgDim = isMobile ? {width: 50, height: 50} : {width: 86, height: 86}
  
    const profileImg = (
      <div style={athleteCard.photoBox}>
        <AthletePhoto
          isMember={false /* This should be claimed. Hard coded for conference */}
          size={'AthleteRacePageCard'}
          photo={profPicUrl}
          name={displayName}
          containerStyle={{
            margin: '0 auto',
            display: 'inline-block'}}
          styles={{...imgDim}}
        />
      </div>
    )

    const profileUrl = `/athletes/${racerId}`
    const profileElement = !isPublicProfile || !racerId
      ? profileImg
      : <Link
          to={profileUrl}
          style={{display:'block', textDecoration:'none'}}
          href={profileUrl}
        >
          {profileImg}
        </Link>

    return (
      <div itemScope itemType="http://schema.org/Person"
           style={athleteCard.contentContainer}>

        <div style={athleteCard.photoContainer}>
          {profileElement}
        </div>

        <div style={{textAlign: isMobile ? 'left' : ''}, athleteCard.athleteName}>
          <Link
            to={profileUrl}
            style={{display:'block', textDecoration:'none', color: '#4a4a4a'}}
            href={profileUrl}
          >
            {displayName}
          </Link>
          </div>

        <div style={athleteCard.details(isMobile)}>
          <div itemProp="gender" style={athleteCard.firstDetail} id="ageGender">
              {genderAndAge}
          </div>
          <div itemProp="homeLocation" style={isMobile && bib ? athleteCard.firstDetail : athleteCard.secondDetail} id="IRPUserLocation">
            {homeTown}
          </div>
          {isMobile && <div itemProp="bib" style={athleteCard.secondDetail}>
          {bib ? `#${bib}` : ''}
          </div> }
        </div>
        {  !isMobile && bib &&
          <div style={athleteCard.bibContainer}>
            <div style={{...athleteCard.bibTitle, color: '#4a4a4a'}}>
              {t('BIB')}
            </div>
            <Bib bib={bib || ''} />
          </div>
        }
        <div style={styles.followButtonContainer(claimed && !isMe, isMobile)}>
          <button
            disabled={false}
            onClick={() => {}}
            style={styles.followButton(isMobile)}
          >{t('Follow') + (firstName ? (' ' + firstName) : '')}</button>
        </div>
      </div>
    )
  }
}

export const AthleteRacePageCard = withTranslation()(AthleteRacePageCardComponent)



/** WEBPACK FOOTER **
 ** ./views/athleteRacePage/AthleteRacePageCard.js
 **/